enum TypeActivite {
  Bureau = "BUREAU",
  AtelierTerrain = "ATELIER_TERRAIN",
  Laboratoire = "LABORATOIRE",
  Autre = "AUTRE",
}

export default TypeActivite;
